// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import { vuetifyThemeConfig } from '../../../shared/utils/vuetify-theme.js'
import '../../../shared/styles/vuetify-theme-static.css' // Import the static CSS file for Vuetify theme overrides (CSP Compliance)

Vue.use(Vuetify)

const opts = {
	theme: {
		disable: true,
		themes: vuetifyThemeConfig
	},
	icons: {
		iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
	}
}

export default new Vuetify(opts)
